// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__39o6j","productName":"Table_productName__yQv6A"};